import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconFolder.module.css';

const IconFolder = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      id="open-folder"
    >
      <path
        fill="#549bff"
        d="m18,5.25h-5.424c-.252,0-.495-.075-.703-.216l-1.922-1.308c-.458-.312-.993-.476-1.546-.476h-3.404c-1.517,0-2.75,1.233-2.75,2.75v11c0,1.517,1.233,2.75,2.75,2.75h10c.414,0,.75-.336.75-.75s4-9.586,4-10v-2c0-.965-.785-1.75-1.75-1.75Z"
      ></path>
      <path
        fill="#bad7ff"
        d="m21.134,8.891c-.333-.407-.827-.641-1.354-.641h-11.141c-1.307,0-2.44.93-2.697,2.211l-1.678,8.392c-.044.221.013.449.155.623s.355.274.58.274h12.36c1.306,0,2.44-.93,2.697-2.21l1.439-7.196c.104-.516-.029-1.046-.362-1.453Z"
      ></path>
    </svg>
  );
};

IconFolder.defaultProps = { className: null, rootClassName: null };

IconFolder.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconFolder;
